module.exports = __webpack_public_path__ + "img/multidevice_mb.0c844f0c.png";